import { GetUploadedVideos } from '@/connection/content/videos';
import { ContentReducerCreator } from '../types';

const loadUploadedVideosReducer = (create: ContentReducerCreator) => {
  return create.asyncThunk(
    async (channel: number) => {
      return await GetUploadedVideos(channel);
    },
    {
      pending: (state) => {
        state.loadingContent = true;
      },
      fulfilled: (state, action) => {
        state.uploadedVideos = action.payload;
      },
      settled: (state) => {
        state.loadingContent = false;
      },
    }
  );
};

export default loadUploadedVideosReducer;
